import { createFileRoute } from "@tanstack/react-router";
import { AestheticBioHomepage } from "../pages/AestheticBioHomepage";

const title = "Aesthetic Bio Maker - Free Aesthetic Bios to Copy and Paste for Instagram";
const description =
  "Use Aesthetic Bio Maker to style bios with aesthetic font styles, bio symbols, and bio templates like kaomoji bio. Make bios for Instagram, Discord, and TikTok.";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" }
    ],
    links: [
      { rel: "canonical", href: "https://aestheticbiomaker.com/" },
      {
        rel: "alternate",
        hrefLang: "en",
        href: "https://aestheticbiomaker.com/"
      },
      {
        rel: "alternate",
        hrefLang: "es",
        href: "https://aestheticbiomaker.com/es/"
      },
      {
        rel: "alternate",
        hrefLang: "x-default",
        href: "https://aestheticbiomaker.com/"
      }
    ]
  }),
  component: AestheticBioHomepage
});
